var isEqual = function isEqual(word1, word2) {
  return word1.toUpperCase() === word2.toUpperCase();
};

export default isEqual;